import type { StatsBlockProps } from '../types';
import { theme, sectionColors } from '../theme';

/**
 * Pure stats band — a row of key figures (homes sold, years in business, rating).
 * Static content (host does not inject data); renders nothing when empty.
 */
export function StatsBlock(props: StatsBlockProps) {
  const { heading, stats = [] } = props;
  const colors = sectionColors(props, { bg: theme.surface, text: theme.text });
  if (!Array.isArray(stats) || stats.length === 0) return null;

  // Responsive columns scale with how many stats there are (2-up on mobile).
  const cols =
    stats.length <= 2
      ? 'sm:grid-cols-2'
      : stats.length === 3
        ? 'sm:grid-cols-3'
        : 'sm:grid-cols-2 lg:grid-cols-4';

  return (
    <section className="px-6 py-12" style={{ ...colors, fontFamily: theme.bodyFont }}>
      <div className="mx-auto max-w-6xl">
        {heading ? (
          <h2
            className="mb-8 text-center text-2xl font-semibold"
            style={{ fontFamily: theme.headingFont }}
          >
            {heading}
          </h2>
        ) : null}
        <div className={`grid grid-cols-2 gap-6 ${cols}`}>
          {stats.map((s, i) => (
            <div key={i} className="text-center">
              <div
                className="text-3xl font-bold sm:text-4xl"
                style={{ color: theme.primary, fontFamily: theme.headingFont }}
              >
                {s.value}
              </div>
              <div className="mt-1 text-sm opacity-70">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
